<template>
  <base-dialog :show-dialog="dialog">
    <template v-slot:body>
      <v-card class="pt-4 pb-2" dark>
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                outlined
                dense
                :placeholder="
                  $t('placeholders.digite', { campo: $t('labels.filial') })
                "
                :label="$t('labels.filial')"
                class="text caption ml-1"
                v-model="value"
                clearable
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-data-table
              dense
              dark
              :headers="selectedHeaderOptions"
              :items="userSystemsList"
              :loading="loadingItems"
              :items-per-page="10"
              :search="value"
              :custom-filter="filterOnTable"
            >
              <template v-slot:item.pin="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn-toggle tile>
                      <v-btn
                        v-on="on"
                        v-bind="attrs"
                        fab
                        color="warning"
                        x-small
                        @click.prevent="pinObject(item)"
                      >
                        <v-icon color="white">mdi-pin-outline</v-icon>
                      </v-btn>
                    </v-btn-toggle>
                  </template>
                  <span>{{ $t('hints.filialOperacao') }}</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red" @click="closeForm()">
            <span class="white--text">
              {{ $t('labels.fechar') }}
            </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from '@/components/shared/base-dialog/BaseDialog.vue'
import { tableMixin } from '@/mixins/component/table/TableMixin'
import { parcelMixin } from '@/mixins/object/parcels/ParcelMixin'
import { translateList } from '@/utils/utils'

import { mapState, mapGetters, mapActions } from 'vuex'
export default {
  components: {
    BaseDialog,
  },
  mixins: [tableMixin, parcelMixin],
  data: () => {
    return {
      timer: null,
      value: '',
      item: undefined,
      dialog: false,
    }
  },
  computed: {
    ...mapState('systemModule', ['loadingItems', 'pagination']),
    ...mapGetters({
      system: 'systemModule/getSystem',
      systemsList: 'systemModule/getSystems',
      authUser: 'authModule/getAuthUser',
    }),
    userSystemsList() {
      if (this.authUser.guest) {
        return this.systemsList.filter(
          (element) => element.CODIGO == this.authUser.filial
        )
      } else if (this.authUser.systems.length > 0) {
        return this.systemsList.filter(
          (element) => this.authUser.systems.lastIndexOf(element.CODIGO) !== -1
        )
      }
      return this.systemsList
    },
    selectedHeaderOptions() {
      const header = [
        { label: 'codigo', text: 'Código', value: 'CODIGO' },
        { label: 'nome', text: 'Nome', value: 'NOME', width: '280px' },
        {
          label: 'acoes',
          text: 'Ações',
          value: 'pin',
          align: 'right',
        },
      ]

      return translateList(header)
    },
  },
  methods: {
    async pinObject(item) {
      if (item.CODIGO !== this.authUser.filial) {
        if (
          this.authUser.systems.length > 0 &&
          this.authUser.systems.lastIndexOf(parseInt(item.CODIGO)) == -1
        ) {
          this.$toasted.error(
            this.$t('validation-messages.semPermissao', {
              recurso: `esta ${this.$t('labels.filial')}`,
            })
          )
          this.cancel()
          return
        }

        await this.getSystem(item.CODIGO)
      }
      this.agree()
    },
    ...mapActions('systemModule', ['getSystems', 'getSystem']),

    async getDados() {
      try {
        if (this.systemList && this.systemList.length <= 0)
          await this.getSystems({})
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },

    filterOnTable(value, search) {
      return (
        value != null &&
        search != null &&
        value
          .toString()
          .toLocaleUpperCase()
          .indexOf(search.toLocaleUpperCase()) !== -1
      )
    },

    closeForm() {
      this.$emit('object-pin', null)
      this.cancel()
    },
    open() {
      this.dialog = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    agree() {
      this.resolve(true)
      this.dialog = false
    },
    cancel() {
      this.resolve(false)
      this.dialog = false
    },
  },
  async mounted() {
    await this.getDados()
  },
}
</script>

<style></style>
